export default collectAttributes;

export function collectAttributes(unit) {
  return Object.assign(
    {},
    unit.attributes,
    unit.formattedAttributes,
    { status: unit.status.name || unit.status.internal_slug },
  );
}
